const VoiceAIButton = () => {
  return (
    <>
      {/* Mobile only - floating button positioned higher to avoid covering content */}
      <div className="md:hidden fixed bottom-36 right-3 z-40">
        <div data-widget-key="b13e2374-6bd9-4e24-b912-324b69f66b47"></div>
      </div>
    </>
  );
};

export default VoiceAIButton;
